import api from 'data/api';

export const loadFinance = api('POST /api/mobile/finance/grid');
